// foodsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  byId: {},
  allIds: [],
  byBarcode: {},
};

const foodsSlice = createSlice({
  name: "foods",
  initialState,
  reducers: {
    setFoods(state, action) {
      state.byId = Object.fromEntries(action.payload.map(f => [f.id, f]));
      state.allIds = action.payload.map(f => f.id);
      state.byBarcode = {};
      action.payload.forEach(f => {
        if (f.barcode) state.byBarcode[f.barcode] = f.id;
      });
    },
    updateFood(state, action) {
      const food = action.payload;
      if (state.byId[food.id]) {
        const old = state.byId[food.id];
        if (old.barcode && old.barcode !== food.barcode) delete state.byBarcode[old.barcode];
        state.byId[food.id] = food;
        if (food.barcode) state.byBarcode[food.barcode] = food.id;
      }
    },
    addFood(state, action) {
      const food = action.payload;
      state.byId[food.id] = { ...state.byId[food.id], ...food };
      if (!state.allIds.includes(food.id)) state.allIds.push(food.id);
      if (food.barcode) state.byBarcode[food.barcode] = food.id;
    },
    removeFood(state, action) {
      const id = action.payload;
      const food = state.byId[id];
      if (food?.barcode) delete state.byBarcode[food.barcode];
      delete state.byId[id];
      state.allIds = state.allIds.filter(fid => fid !== id);
    },
  },
  // ✅ NEW
  extraReducers: (builder) => {
    builder.addCase("app/rehydrate", (state, action) => {
      const foods = action.payload?.foods;
      if (foods?.length) {
        state.byId = Object.fromEntries(foods.map(f => [f.id, f]));
        state.allIds = foods.map(f => f.id);
        state.byBarcode = {};
        foods.forEach(f => {
          if (f.barcode) state.byBarcode[f.barcode] = f.id;
        });
      }
    });
  },
});

export const { setFoods, updateFood, addFood, removeFood } = foodsSlice.actions;

export default foodsSlice.reducer;